import { render, staticRenderFns } from "./CookiesPage.vue?vue&type=template&id=fa3cd1a0"
import script from "./CookiesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiesPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa3cd1a0')) {
      api.createRecord('fa3cd1a0', component.options)
    } else {
      api.reload('fa3cd1a0', component.options)
    }
    module.hot.accept("./CookiesPage.vue?vue&type=template&id=fa3cd1a0", function () {
      api.rerender('fa3cd1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/cookies/CookiesPage.vue"
export default component.exports